/// <reference path="../../typings/tsd.d.ts" />
module warsApp.services {

    export class UserService extends HttpHandlerService {

        private userNameHashTable: HashTable<string> = {};
        private allQueryIssued = false;
        private loggedInUserId: string;
        private impersonationUserId: string;

        constructor(private $http: ng.IHttpService, private $q: angular.IQService, private localStorageService: any) {
            super($http);
        }

        public setLoggedInUserId(userId: string): void {
            this.loggedInUserId = userId;
        }

        public setImpersonationUserId(userId: string): void {
            this.impersonationUserId = userId;
        }

        public clearImpersonationUserId(): void {
            this.impersonationUserId = undefined;
        }

        public isCurrentlyImpersonating(): boolean {
            return this.impersonationUserId !== undefined;
        }

        public getLoggedInUserId(): string {
            return this.impersonationUserId ? this.impersonationUserId : this.loggedInUserId;
        }

        public getCurrentUser(): models.User {
            var data = this.localStorageService.get("authorizationData");
            if (data) {
                return <models.User>(data);
            }

            return null;
        }

        public getUser(userId: string) : ng.IPromise<Wars.Domain.Model.Dtos.UserSearchDto> {
            var d = this.$q.defer();
            this.$http.get("./api/Account/GetUser/" + userId).then(r => {
                d.resolve(r.data);
            });
            return d.promise;
        }

        public getCurrentUserClaims(processConfigId: string): angular.IPromise<Wars.Domain.Model.Dtos.UserClaimDto[]> {
            var d = this.$q.defer();

            this.$http.get("./api/claims/UserClaims/" + processConfigId)
                .then(claims => {
                    d.resolve(claims.data);
                });

            return d.promise;
        }

        public searchUsers(searchCriteria: models.UserSearchCriteria): ng.IPromise<Wars.Domain.Model.Dtos.UserSearchDto[]> {
            var d = this.$q.defer();

            if (searchCriteria.userRepository && searchCriteria.userRepository !== "") {
                this.$http.get("./api/Account/SearchExternalAccounts/" + searchCriteria.userName + "/" + searchCriteria.userRepository).then(r => {
                    d.resolve(r.data);
                });
            } else {
                this.$http.get("./api/Account/SearchAccounts/" + searchCriteria.userName ).then(r => {
                    d.resolve(r.data);
                }); 
            }

            return d.promise;
        }

        public addExternalUser(userSearchDto:Wars.Domain.Model.Dtos.UserSearchDto):ng.IPromise<string> {
            var d = this.$q.defer();

            this.$http.post("./api/Account/AddExternalAccount", userSearchDto).then(result => {
                d.resolve(result.data);
            });

            return d.promise;
        }
    }
}

warsApp.registerService("UserService", ["$http", "$q", "localStorageService",]);